

export default {
  //时间格式化函数
  formatDate :(time,fmt ='yyyy-MM-dd HH:mm:ss')=>{
    let date = new Date(time * 1000);
    let object = {
        "y+": date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    let formatDay = fmt.slice();
    if (/(y+)/.test(fmt)) {
      formatDay = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in object) {
      if (new RegExp("(" + k + ")").test(formatDay)) formatDay = formatDay.replace(RegExp.$1, (RegExp.$1.length == 1) ? (object[k]) : (("00" + object[k]).substr(("" + object[k]).length)));
    }
    return formatDay;
  }
}